export class AppScroll {
    private scrollTarget: number;
    private callback: any;
    private timer: any;
    private counter: number;

    constructor() {
        this.scrollTo = this.scrollTo.bind(this);
        this.doScroll = this.doScroll.bind(this);
    }

    private doScroll() {

        if (this.scrollTarget == null || this.counter > 200) {
            // console.log("*** doScroll() ABORTED", this.counter);
            return;
        }
            
        let delta = Math.floor(this.scrollTarget - window.pageYOffset);

        if (delta === 0 || Math.abs(delta) < 1) {

            // console.log("*** doScroll() Delta is zero", delta, this.scrollTarget, window.pageYOffset);

            this.scrollTarget = null;
            
            if (this.callback != null) {
                this.callback();
                this.callback = null;
            }

            return;
        
        }
        delta = delta > 10 ? Math.floor(delta / 10) : delta;

        if (delta > 30)
            delta = 30;

        // console.log("*** doScroll()", this.scrollTarget, window.pageYOffset);

        window.scrollBy(0, delta);

        this.timer = window.setTimeout(this.doScroll, 10);
        this.counter++;
    }

    scrollTo(targetY: number, callback?: any) {
        window.clearTimeout(this.timer);

        // console.log("*** scrollTo()", targetY);

        this.counter = 0;
        this.callback = callback;
        this.scrollTarget = Math.round(targetY);
        this.doScroll();
    }

    halt = () => {
        this.scrollTarget = null;
        window.clearTimeout(this.timer);
    }
}


// WEBPACK FOOTER //
// ./src/components/shared/appScroll.ts